import Media from "../components/media";
import PasswordResetConfirmationForm from "../containers/password-reset-confirmation-form";
import React from "react";
import redirectIfAuthenticated from "../components/higher-order/redirect-if-authenticated";

function PasswordResetConfirmationPage({ match }) {
  return (
    <div className="l-main l-row">
      <div className="l-wrapper">
        <div className="l-content l-content--80-percent">

          <h1 className="text-center">
            Password Reset
          </h1>

          <p className="text-center">
            Fill out the form below to reset your password.
          </p>

          <div className="batch-g batch-g--padding">
            <div className="batch-c-1-1 batch-c-md-2-3">
              <PasswordResetConfirmationForm token={match.params.token} />
            </div>

            <div className="batch-c-1-1 batch-c-md-1-3">
              <Media
                hiddenOnMobile
                icon="dw-dollars"
                small
                title="Play for MONEY">
                Enter money games for as little as $1 or higher stakes games for more.
              </Media>

              <Media
                hiddenOnMobile
                icon="dw-points"
                small
                title="Play for FREE">
                Create your FREE account &amp; get 1,000 player points. Use your points to enter free games &amp; get started!
              </Media>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default redirectIfAuthenticated(PasswordResetConfirmationPage, "/");
